import { useEffect } from "react";

const DEFAULT_TITLE = "NewsLayer — Crypto & Policy News Intelligence";

export function useSEO(title?: string, description?: string) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description.slice(0, 160));
    }
    return () => { document.title = DEFAULT_TITLE; };
  }, [title, description]);
}
